export default __webpack_public_path__ + "images/share_icon_c6a547e7d6b4e161b1bd6bc365f7fd8d.svg";